import { RootState } from "../index";
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { fetchTemplate, fetchTemplates } from "src/actions/sendgrid/templatesActions";

export interface TemplateInterface {
  id: string;

  name: string;

  thumbnail_url: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0
};

const templatesAdapter = createEntityAdapter<TemplateInterface>();

const slice = createSlice({
  name: 'templates',
  initialState: templatesAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchTemplates.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.templates;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchTemplate.fulfilled, (state, action) => {
        const template = Object.values(action.payload.template)[0];
        state.entities[template.id] = template;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectTemplateById,
  selectIds: selectTemplateIds,
  selectEntities: selectTemplateEntities
} = templatesAdapter.getSelectors<RootState>(state => state.sendgrid.templates);
